import React from 'react';
import PrivateRoute from 'PrivateRoutes';
const REPORT = React.lazy(()=> import(/* webpackChunkName: "CallbackReports" */'./components'));

const routes = () => (
  <PrivateRoute exact path="/reporting/callback-report" component={REPORT} />
);

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/reporting/CallBackReport/routes.js